var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.45001V15C5 15.5304 5.21071 16.0392 5.58579 16.4142C5.96086 16.7893 6.46957 17 7 17H14.71C15.3677 17.0019 16.0078 16.7876 16.5318 16.3901C17.0558 15.9926 17.4346 15.4339 17.61 14.8L18.91 10.05C19.0085 9.69253 19.0231 9.31715 18.9528 8.95308C18.8825 8.58902 18.7292 8.24608 18.5047 7.95096C18.2802 7.65584 17.9906 7.4165 17.6586 7.25157C17.3265 7.08663 16.9608 7.00055 16.59 7.00001H12L12.35 2.74001C12.3695 2.51843 12.3425 2.29523 12.2709 2.08465C12.1992 1.87406 12.0845 1.68074 11.9339 1.517C11.7833 1.35327 11.6003 1.22273 11.3964 1.13371C11.1926 1.04469 10.9724 0.999158 10.75 1.00001C10.5148 0.999717 10.2826 1.05159 10.0699 1.15188C9.85717 1.25217 9.66937 1.3984 9.52 1.58001L5.93 5.89001C5.33007 6.60828 5.00098 7.51416 5 8.45001Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.25C1.5 8.11193 1.38807 8 1.25 8C1.11193 8 1 8.11193 1 8.25V16.75C1 16.8881 1.11193 17 1.25 17C1.38807 17 1.5 16.8881 1.5 16.75V8.25Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.0cbb52cd4cbe239aabc96409340069ad.svg";
export { ForwardRef as ReactComponent };